import { Component, Input, OnInit, ViewChild, ElementRef, Output, EventEmitter } from "@angular/core";
import { BaseComponent, UserService, EventBusService, StorageKeys, StorageService, ProductService, ContentService } from "@mypxplat/xplat/core";
import { AppService } from "@mypxplat/xplat/web/core";
import { css, cx } from "styled-system/css";

@Component({
  selector: "fui-content-filter",
  templateUrl: "content-filter.component.html",
  standalone: false,
})
export class FuiContentFilterComponent extends BaseComponent implements OnInit {
  @Input() resultsCount: number = 0;
  @Input() showViewOption: boolean = true;
  @Input() showResults: boolean = true;
  @Input() showSortOptionsToggle: boolean = true;
  @Input() showSidebarToggle: boolean = true;
  @Input() searchPlaceholder: string = "my_gear.search";
  @Input() showSearchInput: boolean = true;
  @Input() searchOnlyOnEnter: boolean = false;
  @Input() activeQuery: string = "";
  @Input() filters: any;
  @Input() widerSearch: boolean = false;
  @Output() queryChanged: EventEmitter<string> = new EventEmitter();
  @Output() refineClicked: EventEmitter<void> = new EventEmitter();
  @Output() showMobileFiltersClicked: EventEmitter<void> = new EventEmitter();
  @Output() clearQuery: EventEmitter<void> = new EventEmitter();
  @Output() clearFilter: EventEmitter<void> = new EventEmitter();
  @Output() sortChanged: EventEmitter<any> = new EventEmitter();
  public refining: boolean = true;
  public showSortOptions: boolean = false;

  public settings: any = {
    sort_by: "date",
    sort_direction: "desc",
    group_by_type: true,
  };

  constructor(
    userService: UserService,
    public appService: AppService,
    public storageService: StorageService,
    public productService: ProductService,
    public contentService: ContentService
  ) {
    super(userService);
  }

  ngOnInit(): void {
    this.settings.sort_by = this.appService.sortBy;
    this.settings.sort_direction = this.appService.sortDirection;
    this.settings.group_by_type = this.appService.sortGroupByType;
  }

  sortBy(type) {
    this.appService.sortBy = type;
    this.settings.sort_by = type;
    this.sortChanged.next({
      sort_by: type,
      sort_direction: this.settings.sort_direction,
    });
  }

  queryChangedEvent(event: any) {
    if (!this.searchOnlyOnEnter) {
      this.queryChanged.next(event);
    }
  }

  showMobileFilters() {
    this.showMobileFiltersClicked.next();
  }

  sortDirection(direction) {
    this.appService.sortDirection = direction;
    this.settings.sort_direction = direction;
    this.sortChanged.next({
      sort_by: this.settings.sort_by,
      sort_direction: direction,
    });
  }

  refine() {
    this.refining = !this.refining;
    this.refineClicked.next();
  }
}
